import { Reveal } from "./Reveal";

const PRINCIPLES = [
  {
    title: "Precision over volume",
    body: "Fewer, better decisions. Careful judgement early tends to cost less than correction later.",
  },
  {
    title: "Built to be operated",
    body: "A system's launch is one day of its life. The rest is running, changing and extending it.",
  },
  {
    title: "Clarity as a discipline",
    body: "Clear architecture, clear code, clear communication. Complexity is added only where it earns its place.",
  },
];

export function About() {
  return (
    <section
      id="about"
      className="scroll-mt-24 relative overflow-hidden border-t border-hairline py-24 sm:py-32 lg:py-36"
    >
      <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 top-0 h-px rule-glow" />

      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="grid gap-8 lg:grid-cols-[minmax(0,0.85fr)_minmax(0,1.15fr)] lg:gap-16">
          <Reveal className="flex items-center gap-4 self-start">
            <span className="h-px w-10 bg-primary" />
            <p className="eyebrow">About</p>
          </Reveal>

          <div>
            <Reveal>
              <h2 className="max-w-[16ch] font-display text-[clamp(1.9rem,4.4vw,3.4rem)] leading-[1.04]">
                Technology built with intent.
              </h2>
            </Reveal>
            <Reveal delay={100}>
              <div className="mt-8 grid max-w-3xl gap-6 text-base leading-relaxed text-muted-foreground sm:grid-cols-2 sm:gap-10">
                <p>
                  We build digital products, platforms and the cloud foundations underneath
                  them — the design that defines a system, the engineering that realises it,
                  and the infrastructure that keeps it running.
                </p>
                <p>
                  Our standard is simple: technology should be dependable. That means considered
                  architecture, disciplined delivery, and software that remains understandable
                  long after the first release.
                </p>
              </div>
            </Reveal>
          </div>
        </div>

        <div className="mt-20 grid gap-px sm:mt-24 lg:grid-cols-3">
          {PRINCIPLES.map((principle, i) => (
            <Reveal
              key={principle.title}
              delay={i * 110}
              className="group relative border-t border-hairline pt-8 lg:pr-12"
            >
              <span
                aria-hidden="true"
                className="absolute left-0 top-0 h-px w-0 bg-primary transition-[width] duration-700 ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:w-full"
              />
              <span className="num text-[0.65rem] text-primary">0{i + 1}</span>
              <h3 className="mt-6 font-display text-xl tracking-[-0.015em]">{principle.title}</h3>
              <p className="mt-4 max-w-sm text-[0.95rem] leading-relaxed text-muted-foreground">
                {principle.body}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
